<script>
import appClose from '@/components/common/app-close'

export default {
  name: 'app-header-info',
  props: {
    account: {
      type: Object, default() {
        return {
          phone: '',
          name: '',
          logo: ''
        }
      }
    },
    isMobileVersion: Boolean
  },
  components: {
    appClose
  },
  data() {
    return {
      logoIsLoad: true
    }
  },

  computed: {
    isIframe() {
      return window.name === 'winwin'
    }
  },

  methods: {
    closeCatalog() {
      window.parent.postMessage('', '*')
    },

    logoNotLoad() {
      this.logoIsLoad = false
    }
  }
}
</script>

<template>
  <div
    class="h-full grid grid-cols-headerInfo"
    :class="{
      'grid-cols-headerInfo': isIframe && !isMobileVersion,
      'grid-cols-headerInfoWithoutCloseBtn': !isIframe,
      'grid-cols-headerInfoMobile': isIframe && isMobileVersion,
    }"
  >
    <div class="flex items-center text-leadNameColor text-2xl font-bold">
      <i
        v-if="logoIsLoad"
        class="w-24 h-16 pr-1"
      >
        <a 
          v-if="account.underLogoLink"
          :href="account.underLogoLink"
          @click="closeCatalog"
        >
          <img
            class="w-full h-full object-contain"
            alt="logo"
            :src="account.logo"
            @error="logoNotLoad"
          >
        </a>
        <img
            v-else
            class="w-full h-full object-contain"
            alt="logo"
            :src="account.logo"
            @error="logoNotLoad"
        >
      </i>
      <span v-else-if="!isMobileVersion">
        {{ account.name }}
      </span>
    </div>
    <div
      v-show="account.phone"
      class="flex justify-center items-center p-1.5 text-leadNameColor"
      :class="{
        'border-r-2':  isIframe
      }"
    >
      <a :href="`tel:${account.phone}`"
         class="text-xl font-bold flex items-center transition duration-200 hover:text-blue-500 hover:fill-current hover:text-headerHover">
        <svg class="h-5 w-5  " xmlns="http://www.w3.org/2000/svg"
             x="0px" y="0px"
             width="35px" height="35px" viewBox="0 0 35 35"
             xml:space="preserve"><g><path d="M25.302,0H9.698c-1.3,0-2.364,1.063-2.364,2.364v30.271C7.334,33.936,8.398,35,9.698,35h15.604
		c1.3,0,2.364-1.062,2.364-2.364V2.364C27.666,1.063,26.602,0,25.302,0z M15.004,1.704h4.992c0.158,0,0.286,0.128,0.286,0.287
		c0,0.158-0.128,0.286-0.286,0.286h-4.992c-0.158,0-0.286-0.128-0.286-0.286C14.718,1.832,14.846,1.704,15.004,1.704z M17.5,33.818
		c-0.653,0-1.182-0.529-1.182-1.183s0.529-1.182,1.182-1.182s1.182,0.528,1.182,1.182S18.153,33.818,17.5,33.818z M26.021,30.625
		H8.979V3.749h17.042V30.625z"/></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g>
</g></svg>
        {{ account.phone }}
      </a>
    </div>
    <div
      v-if="isIframe"
      class="flex justify-end items-center p-1.5"
    >
      <div
        class="w-5 h-5 fill-current text-leadNameColor text-base font-light items-center cursor-pointer transition duration-200 hover:text-blue-500 hover:fill-current hover:text-headerHover"
        @click="closeCatalog"
      >
        <appClose />
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>
